import React, { useState } from 'react';
import { Button, Card } from '@veneer/core';
import { propOr } from 'ramda';
import { PSA_SUPPORTED_LANGUAGES_KEY, RTL_LANG } from '../constants/i18n';
import { determineLocale } from '../utils/determineLocale';
import { useHistory, useParams } from 'react-router';
import {
  PSABodyText,
  PSAButtonContainer,
  PSACardContent,
  PSAFooter,
  PSAPage,
  PSAPageContainer,
  PSATitle
} from '../styles/PSAGeneralConsent';
import { useMemo } from 'react';
import { handleMergeContentStackAndAlpacaData } from '../utils/mergingContentHelper';
import { psaBasic, psaProduct } from '../constants/purposeID';

function PSAGeneralConsent({
  handleClick,
  declineAllClick,
  csData = {},
  alpacaData,
  loading,
  declineAllLoading,
  reTarget,
  query,
  requiredWelcomeContent = '',
  smallButton,
  errorResponse
}) {
  const errorCode = propOr(0, 'code', errorResponse);
  const errorMessage = propOr('', 'message', errorResponse);
  const title = propOr('', 'title', csData);
  const acceptButton = propOr('', 'acceptAllButton', csData);
  const declineButton = propOr('', 'declineAllButton', csData);
  const body = propOr('', 'body', csData);
  const secondaryBodyText = propOr('', 'secondaryBodyText', csData);
  const supplementalText = propOr('', 'supplementalText', csData);
  const history = useHistory();
  const params = useParams();
  const { country, language } = determineLocale(PSA_SUPPORTED_LANGUAGES_KEY);
  const [isDesktop, setDesktop] = useState(false);
  const [isRestOfWorld, setIsRestOfWorld] = useState(null);
  const isRTL = RTL_LANG.includes(language);

  const mergedSecondaryBodyText = useMemo(() => {
    if (alpacaData && csData) {
      return handleMergeContentStackAndAlpacaData(secondaryBodyText, alpacaData, [
        psaBasic,
        psaProduct
      ]);
    }
    return '';
  }, [csData, alpacaData]);

  return (
    <PSAPage className="body-regular" isRTL={isRTL}>
      <PSAPageContainer>
        <PSATitle id="psa-title-text">{title}</PSATitle>
        <Card
          background="filled"
          customStyle={{ borderRadius: '7px' }}
          content={
            <PSACardContent>
              <PSABodyText
                dangerouslySetInnerHTML={{
                  __html: [body, mergedSecondaryBodyText, supplementalText].join('')
                }}
              />
              <PSAButtonContainer>
                <Button
                  onClick={declineAllClick}
                  appearance="secondary"
                  loading={loading}
                  disabled={loading}
                  small={smallButton}
                  id="psa-consent-decline-button"
                >
                  {!loading && declineButton}
                </Button>
                <Button
                  onClick={handleClick}
                  loading={loading}
                  disabled={loading}
                  small={smallButton}
                  appearance="secondary"
                  id="psa-consent-accept-button"
                >
                  {!loading && acceptButton}
                </Button>
              </PSAButtonContainer>
            </PSACardContent>
          }
        />
      </PSAPageContainer>
    </PSAPage>
  );
}

export default PSAGeneralConsent;
